import type { TFunction } from 'i18next';
import { z } from 'zod';

export const createFlexWorkerContractSchema = (t: TFunction) =>
  z
    .object({
      contractStartDate: z
        .string({
          required_error: t('flex-worker-detail.contract.form.validation.start-date-required'),
          invalid_type_error: t('flex-worker-detail.contract.form.validation.start-date-required'),
        })
        .min(1, t('flex-worker-detail.contract.form.validation.start-date-required')),
      contractEndDate: z.string().nullable(),
      contractHours: z.coerce
        .number({
          invalid_type_error: t('flex-worker-detail.contract.form.validation.invalid-type'),
        })
        .nonnegative({
          message: t('flex-worker-detail.contract.form.validation.negative-number'),
        })
        .nullable(),
    })
    .refine(
      (data) => {
        if (data.contractStartDate && data.contractEndDate) {
          return new Date(data.contractStartDate) <= new Date(data.contractEndDate);
        }
        return true;
      },
      {
        message: t('flex-worker-detail.contract.form.validation.start-date-set-after-end-date'),
        path: ['contractStartDate'],
      }
    );
